import React, { useEffect,useState} from 'react'
import './style.css'
import { useNavigate } from "react-router-dom";
import categoriesIcon from '../../../assets/icons/category.svg';
import BranchDetailsInfoContainer from '../../../components/DashboardComponents/BranchDetailsInfoContainer/BranchDetailsInfoContainer';
import ProfileIntiationLablesContainer from '../../../components/DashboardComponents/ProfileIntiationLablesContainer';
import GetRequest from '../../../service/GetRequest';
import { Button } from 'primereact/button';
import CookieHandler from '../../LandingPage/Authentication/CookieHandler';


const CategoriesListPage = ({ setActivePath , header, description, headerActionName, headerActionNavigationLink, isSaveAndContinueRequired, isHeaderActionRequired, saveButtonNavigationLink}) => {
  const navigate = useNavigate();
  const userId = CookieHandler.getCookie("userid");
  const navigationLinkToAddCategory = "/store/add/new/category/";

  const [BranchList,setBranchList ] = useState([]);
  const [storeName, setStoreName] =useState("");

  
  useEffect(() => {
    setActivePath(" Branches");

    GetRequest("v1/store-management-service/view/my/store",true)
            .then(response => {
                if (!response || response === undefined) {
                    console.log("No store found for this user");
                } else {
                    console.log(response);
                    setStoreName(response.brandName)
                    setBranchList(response.storeBranches);
                }
            })
            .catch(error => {
                console.error("Error fetching store data:", error);
            });
  }, [setActivePath,userId]);


  return (
    <div className="outlet-container">
      <div className="background-white">
        <div className="background-white-sub-container">                  <br/>

        <ProfileIntiationLablesContainer title="Create Categories" description="Add store details like color, font theme etc" status={true} navigation={headerActionNavigationLink} icon={categoriesIcon} iconBackgroundColor="#CE7B69" actionName="Add Category" isActionRequired={isHeaderActionRequired}/>


     <br/>
     

      {BranchList.length === 0 ? (
            <div>
              <div className="flex justify-center items-center h-screen">
                <div className="text-center">
                  <div className="mb-5">No branches found</div>
                  <div className="mb-5">Please create some branches before proceed</div>
                </div>
              </div>
            </div>
          ) : (
            <div className="branch-details-container-padding">
              {BranchList.map((item, index) => (
                <BranchDetailsInfoContainer
                  key={index} // Ensure each component has a unique key
                  paddingRequired // Assuming you always want padding
                  actionRequired // Assuming action is always required
                  actionName="Add Categories"
                  storeName={storeName}
                  branchId={item.id}
                  postcode={item.postcode}
                  country={item.country}
                  county={item.county}
                  city={item.city}
                  addressLine3={item.addressLine3}
                  addressLine2={item.addressLine2}
                  addressLine1={item.addressLine1}
                  navigationLink={navigationLinkToAddCategory}
                />
              ))}
            </div>
          )}
     
           {isSaveAndContinueRequired && (
            <Button onClick={() => navigate(saveButtonNavigationLink)} variant="contained" label="Save and Continue"/>
        )}
          </div>
        </div>
        </div>



  )
}

export default CategoriesListPage
